module.exports = __webpack_public_path__ + "img/camper_interiour_2.7d318f3b.jpg";